import React from 'react';

import styles from './not-found.module.scss';
import Page from '@/components/Page/Page';

export default function NotFound() {
  return (
    <Page
      pageTitle="Page 404"
      className={styles['not-found']}
    >
      <h1>404</h1>
      <h2>Page Not Found</h2>
    </Page>
  );
}
